/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
import { usePhoneMask } from '../index.js';
import type { UsePhoneMaskT } from '../index.js';

// test we expose the namespace and the namespace follows our deliverable conventions
type ComponentPropsForApp = UsePhoneMaskT.Props;
type ComponentPropsInternals = UsePhoneMaskT.InternalProps;
type ComponentPropsDefaultProps = UsePhoneMaskT.DefaultProps;
type ComponentPropsOptionalProps = UsePhoneMaskT.OptionalProps;
type ComponentPropsRequiredProps = UsePhoneMaskT.RequiredProps;

const testRequiredProps: ComponentPropsRequiredProps = {
  valueSetter: () => {},
};

const testOptionalProps: ComponentPropsOptionalProps = {};

// difference Props and InternalProps is that InternalProps has all the default props filled in
// Props allows for partial defaults
const testPartialDefaults: Partial<ComponentPropsDefaultProps> = {
  onChange: () => {},
  isInternational: false,
};

const testProps: ComponentPropsForApp = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testPartialDefaults,
};

const testPropsAsSyntax = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testPartialDefaults,
} as ComponentPropsForApp;

// InternalProps requires all defaults to be filled in
const testCompleteDefaults: Required<ComponentPropsDefaultProps> = {
  onChange: () => {},
  onKeyDown: () => {},
  onBlur: () => {},
  isInternational: true,
};

const testInternalProps: ComponentPropsInternals = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testCompleteDefaults,
};

const testInternalPropsAsSyntax = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testCompleteDefaults,
} as ComponentPropsInternals;

// using the explicit type definition, if there is an error, it will be marked on the key that is wrong
const testExplicitDefinition: ComponentPropsForApp = {
  valueSetter: () => {},
  onChange: () => {},
  onKeyDown: () => {},
  onBlur: () => {},
  isInternational: true,
};

// using the "as" syntax, if there is an error, it will be marking the whole object as wrong because it is not compatible with the type
const testInferedTypeCompatibility = {
  valueSetter: () => {},
  onChange: () => {},
  onKeyDown: () => {},
  onBlur: () => {},
  isInternational: true,
} as ComponentPropsForApp;

const testDefinitionAsConst = {
  valueSetter: () => {},
  onChange: () => {},
  onKeyDown: () => {},
  onBlur: () => {},
  isInternational: true,
} as const;

const ExampleUsageComponent = () => {
  // works with explicitly casted props, all syntaxes
  const inputProps = usePhoneMask({
    ...testExplicitDefinition,
  });
  const inputProps2 = usePhoneMask({
    ...testInferedTypeCompatibility,
  });
  const inputProps3 = usePhoneMask({
    ...testDefinitionAsConst,
  });
  // works with inline values
  const { onChange, onKeyDown } = usePhoneMask({
    valueSetter: () => {},
    onChange: () => {},
    onKeyDown: () => {},
    onBlur: () => {},
    isInternational: true,
  });

  return <div></div>;
};
